import React, {useState, useEffect, useRef} from 'react'

import BrassPanel from '../../../components/BrassPanel'

function MachineProgress({instruction, startMachine, setStartMachine, phase, winningPhase}) {
    const [arrowPositions] = useState(() => calculateArrowPositions())
    const [arrowPos, setArrowPos] = useState(arrowPositions[phase])
    const [arrowShake, setArrowShake] = useState(false)
    const arrowRef = useRef()
    const displayRef = useRef()
    
    function calculateArrowPositions() {
        const totalDeg = 150
        const posGap = totalDeg / winningPhase
        const posArr = [75]
        for (let i=1; i < winningPhase + 1; i++) {
            const newPos = 75 - (posGap * i)
            posArr.push(newPos)
        }
        return posArr
    }
    
    function handleClick() {
        !startMachine && setStartMachine(true)
    }
    
    useEffect(() => {
        arrowRef.current.style.transform = `translate(-50%, 50%) rotate(${arrowPos}deg)`
    }, [arrowPos])
    
    useEffect(() => {
        const randomTime = Math.floor((Math.random() * 500) + 100)
        const timer = setTimeout(() => {
            const shakeDeg = arrowShake ? arrowPos + 5 : arrowPos
            arrowRef.current.style.transform = `translate(-50%, 50%) rotate(${shakeDeg}deg)`
            setArrowShake(prevState => !prevState)
        }, randomTime)
        return () => clearTimeout(timer)
    }, [arrowShake, arrowPos])
    
    useEffect(() => {
        setArrowPos(arrowPositions[phase])
    }, [phase, arrowPositions])
    
    return (
        <BrassPanel extraClasses='machine_panel machine_panel-progress'>
            <div className='machine_display machine_display-progress'>
                <div className='machine_progressDisplay_arrow' ref={arrowRef}></div>
            </div>
            <div className='machine_instructionContainer'>
                <button className='machine_instruction_btn' onClick={handleClick}>Initiate Shutdown</button>
                <input type='text' className='machine_display machine_display-instruction' value={instruction} readOnly ref={displayRef}/>
            </div>
        </BrassPanel>
    )
}

export default MachineProgress